import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import './fadeIn.css'; // Ensure this path matches your file structure

const FadeInSection = ({ children }) => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Only trigger once
    threshold: 0.1,    // Percentage of the element that needs to be visible
    initialInView: true
  });

  return (
    <div ref={ref} className={`fade-in-section ${inView ? 'is-visible' : ''}`}>
      {children}
    </div>
  );
};

export default FadeInSection;
